export default "/assets/images/technology-graph-01.f056e26f1d2051d5.png";